import Sidebar from "layouts/sidebar";
import JsonBuilder from "pages/json-builder";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "common/hooks";
import { Box, createTheme, ThemeProvider } from "@mui/material";
import NodeForm from "common/components/NodeForm";
import { ToastContainer } from "react-toastify";
import { setSectionSummeryGroupId } from "store/slices/nodes";
const theme = createTheme({
  shape: {
    borderRadius: 8, // custom border radius
  },
});
function App() {
  const dispatch = useAppDispatch();
  const {
    json: { nodes },
    sectionSummeryGroupId,
  } = useAppSelector((state) => state.nodes);
  useEffect(() => {
    if (!nodes?.some((n: any) => n?.id === sectionSummeryGroupId))
      dispatch(setSectionSummeryGroupId(null));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nodes, sectionSummeryGroupId]);
  return (
    <ThemeProvider theme={theme}>
      <Sidebar />
      <main style={{ height: "100vh", overflow: "auto" }} className={`main mainContentSection`}>
        <Box sx={{ p: 3 }}>
          <JsonBuilder />
        </Box>
      </main>
      <NodeForm />
      <ToastContainer position="bottom-left" />
    </ThemeProvider>
  );
}

export default App;
